export default function stringSort(a, b) {
  const as = String(a).toLowerCase();
  const bs = String(b).toLowerCase();

  if (as < bs) {
    return -1;
  }
  if (as > bs) {
    return 1;
  }
  return 0;
}
